module.exports = __webpack_public_path__ + "static/img/menu_p.5a109f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/menu_p.png
// module id = eFe/
// module chunks = 9